import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/geist-latin.woff2%22,%22weight%22:%22300%20700%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22variable%22:%22--font-geist-sans%22,%22fallback%22:[%22-apple-system%22,%22BlinkMacSystemFont%22,%22Segoe%20UI%22,%22sans-serif%22]}],%22variableName%22:%22geistHome%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'geistHome', 'geistHome Fallback', -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
